
export default {
  name: 'BbTreeview',
  data() {
    return {
      active: this.initialState,
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: [Boolean, undefined],
      default: undefined,
    },
    initialState: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'No layouts found',
    },
    isTreeSelectable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOpenProvided() {
      return typeof this.isOpen !== 'undefined';
    },
    shouldBeOpened() {
      return this.isOpenProvided ? this.isOpen && 'active' : this.active && 'active';
    },
    computedStyle() {
      return this.loading ? 'loading' : this.shouldBeOpened;
    },
    activeButton() {
      return this.isActive ? 'bb-treeview__button--is-active' : this.isActive;
    },
    selectable() {
      return this.isTreeSelectable ? 'is-selectable' : 'non-selectable';
    },
  },
  methods: {
    changeState() {
      this.active = !this.active;
      this.$emit('change:is-active', this.active);
    },
    buttonClickHandler() {
      if (!this.isTreeSelectable) {
        this.changeState();
      }
    },
    iconClickHandler(event) {
      this.changeState();
      event.stopPropagation();
    },
  },
};
